import axios from "axios";
import { getDeviceId } from "../utils/device";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.mentalswasthya.com/api";
    // process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api";

const API_KEY =
  process.env.REACT_APP_API_KEY ||
  "dyUIT372362iljkmsd,9zjs812`@@32389nmidhscjsdnhsuxe4e5rc67ivhjkp9,.,";

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "x-api-key": API_KEY,
  },
  withCredentials:true
});

export const isTokenExpired = (token) => {
  if (!token) return true;  
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return false;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const { exp } = JSON.parse(jsonPayload);
    if (exp && Date.now() >= exp * 1000) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

export const refreshAccessToken = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/refresh`,
      {},
      {
        withCredentials: true,
        headers: {
          "x-api-key": API_KEY,
        },
      }
    );
    const newAccessToken = response.data?.data?.accessToken;
    if (newAccessToken) {
      localStorage.setItem("token", newAccessToken);
      return newAccessToken;
    }
    throw new Error("No access token returned from refresh");
  } catch (err) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    throw err;
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["x-device-id"] = getDeviceId();
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;

    if (error?.response?.data?.code === "DEVICE_SWITCHED") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        sessionStorage.setItem(
          "device_switched_msg",
          "You have been signed out because your account was logged in on another device (One-Device Policy)."
        );
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }

    if (
      status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/refresh") &&
      !originalRequest.url?.includes("/auth/login")
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newAccessToken = await refreshAccessToken();
        isRefreshing = false;
        processQueue(null, newAccessToken);

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshErr) {
        isRefreshing = false;
        processQueue(refreshErr, null);

        if (
          window.location.pathname !== "/login" &&
          !window.location.pathname.includes("/register")
        ) {
          window.location.href = "/login";
        }
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);


 